import { isEmpty } from "lodash"
import moment from "moment"
import toast from "toastr"
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
//redux
import { useDispatch, useSelector } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import {
  getUserTimeSheetReport,
  screenVerified,
  workReports,
  setIsMobile
} from "store/actions"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import FilterLayout from "../Components/FilterLayout"
import {
  BrkHrs,
  ClientName,
  EndtTime,
  IdleHrs,
  ManualHrs,
  PrivateHrs,
  ProjectName,
  StartDateTime,
  Total,
  ActiveHrs,
  StartTime,
  EndTimess,
  ReportInsertedTime,
} from "./VerifyScreenCol"
import { getTeamLookup } from "store/createTeam/action"
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import { getAuthorizationToken } from "helpers/storagehelper"
import VerifyTeamModal from "../VerifyMyTeams/VerifyTeamModal"
import TableContainer from "./customtable"
import MobileTable from "../../../components/Common/MobileTable/MobileTable"
import VerifyScreenModal from "./VerifyScreenModalCopy"

function VerifyScreen() {
  //meta title
  document.title = "Verifymyhours | TenderSoftware - Flexi TracBoard"

  const hoursList = [
    {
      label: "Active",
      value: "Active",
      dataField: "activeHours",
    },
    {
      label: "Idle",
      value: "Idle",
      dataField: "idleHours",
    },
    {
      label: "Break",
      value: "Break",
      dataField: "breakHours",
    },
    {
      label: "Private",
      value: "Private",
      dataField: "privateHours",
    },
    {
      label: "Manual",
      value: "Manual",
      dataField: "manualHours",
    },
  ]

  // Default date logic: yesterday until 11:50 AM, then today after 11:50 AM
  const getDefaultDate = () => {
    const now = new Date()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    
    // If current time is before 11:50 AM, use yesterday, otherwise use today
    if (currentHour < 11 || (currentHour === 11 && currentMinute < 50)) {
      const yesterday = new Date(now)
      yesterday.setDate(yesterday.getDate() - 1)
      return yesterday
    }
    return now
  }

  const [startDate, setStartDate] = useState(getDefaultDate())
  const [endDate, setEndDate] = useState(getDefaultDate())
  const [hideDateColumn, sethideDateColumn] = useState(true)
  const [ismodal, setismodal] = useState(false)
  const [isReportModal, setisReportModal] = useState(false)
  const [selectedHours, setSelectedHours] = useState([])
  const [screenResponse, setscreenResponse] = useState()
  const [timeSheetLists, setData] = useState([])
  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const toDate = moment(new Date(endDate)).format("YYYY-MM-DD")
  const [activeScreenFilter, setActiveScreenFilter] = useState("UNVERIFIED")
  const [handleAccordion, sethandleAccordion] = useState(false)
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [selectedSubcategory, setselectedSubcategory] = useState(null)
  const [selectedMainCategory, setselectedMainCategory] = useState(null)
  const [connection, setconnection] = useState(null)
  const [expandRowDetails, setExpandRowDetails] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)

  const dispatch = useDispatch()
  const email = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.email
  const { reports, screens, companySetting, isMobile } = useSelector(state => ({
    reports: state.timesheet.timeSheetReportSuccessList,
    screens: state.timesheet.screenVerifiedSuccessList,
    companySetting: state?.Login?.userDetails?.data,
    isMobile: state?.teams?.isMobile
  }))

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 900))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    dispatch(getTeamLookup())
  }, [])

  const toggleViewModal = e => {
    if (!ismodal) {
      const screenVerifyparams = {
        accountid: JSON.parse(localStorage.getItem("authUser") || "{}")?.data
          ?.defaultAccountId,
        includeBase64: "false",
        filterEmptyResponses: "false",
        startDateTime: "2023-04-21", //fromDate,
        endDateTime: "2023-04-21", //toDate
        filterVerified: null,
      }
      // timeSheetLists
      dispatch(screenVerified(screenVerifyparams))
    }
    setismodal(!ismodal)
    setCurrentIndex(0);
  }
  //handleSignalr
  useEffect(() => {
    const connect = new HubConnectionBuilder()
      // Hub now requires auth: supply the JWT. @microsoft/signalr sends it as a
      // Bearer header on negotiate and as the "access_token" query value on the socket.
      .withUrl(`${process.env.REACT_APP_API_URL}/MessageHub`, {
        accessTokenFactory: () => getAuthorizationToken(),
      })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build()
    setconnection(connect)
  }, [])

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection
            .invoke("OnConnected", email)
            .then(() => {
              console.log("Group Connected")
            })
            .catch(function (err) {
              //return console.error(err.toString());
              console.log(err.toString())
            })
        })
        .catch(error => console.log(error))
      connection.on("SendMessageToGroup", function (receivedMessages) {
        if (JSON.parse(receivedMessages).SENDER === "System") {
        } else {
          toast.info(receivedMessages)
        }
        // toast.info(receivedMessages)
        // BindGroupToGrid(receivedMessages);
      })
    }
  }, [connection])

  // heading title in react table
  const HeaderFormater = (column, colIndex) => {
    return <strong>{column.text}</strong>
  }
  const timeSheetHeaderColumns = useMemo(
    () => [
      {
        text: "Date",
        dataField: "date",
        sort: true,
        filterable: true,
        hidden: hideDateColumn ? true : false,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        footer: <span />,
        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center", width: '9%' }
        },
      },

      {
        text: "Start Time",
        dataField: "startTime",
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          />
        ),
        sort: true,
        sortFunc: (a, b, order) => {
          // Convert time strings to numbers
          const timeToNumber = time => {
            const [hours, minutes, seconds] = time.split(':').map(Number);
            return hours * 3600 + minutes * 60 + seconds;
          };
          
          // Convert time strings to numbers for comparison
          const timeA = timeToNumber(moment(a).format('HH:mm:ss'));
          const timeB = timeToNumber(moment(b).format('HH:mm:ss'));
      
          // Perform custom comparison based on order
          if (order === 'asc') {
            return timeA - timeB;
          } else {
            return timeB - timeA;
          }
        },
        // filterable: true,
        formatter: StartDateTime,
        footer: <span />,
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "End Time",
        dataField: "endTime",
        disableFilters: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        sort: true,
        sortFunc: (a, b, order) => {
          // Convert time strings to numbers
          const timeToNumber = time => {
            const [hours, minutes, seconds] = time.split(':').map(Number);
            return hours * 3600 + minutes * 60 + seconds;
          };
          
          // Convert time strings to numbers for comparison
          const timeA = timeToNumber(moment(a).format('HH:mm:ss'));
          const timeB = timeToNumber(moment(b).format('HH:mm:ss'));
      
          // Perform custom comparison based on order
          if (order === 'asc') {
            return timeA - timeB;
          } else {
            return timeB - timeA;
          }
        },
        filterable: true,
        formatter: EndtTime,
        footer: <span />,
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: companySetting?.MainCategory,
        dataField: "clientName",
        disableFilters: true,
        sort: false,
        style:{ color: '#edb36700' },
        filterable: true,
        Cell: cellProps => {

          return <ClientName {...cellProps} />
        },
        footer: info => <span />,
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: companySetting?.SubCategory,
        dataField: "projectName",
        sort: false,
        disableFilters: true,
        filterable: true,
        hidden: false,
        Cell: cellProps => {
          return <ProjectName {...cellProps} />
        },
        style:{ color: '#edb36700' },
        footer: info => (
          <>
            <span className="bold d-flex justify-content-end">Total: </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Private",
        dataField: "privateHours",
        disableFilters: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        filterable: true,
        Cell: cellProps => {
          return <PrivateHrs {...cellProps} />
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("privateHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Active",
        dataField: "activeHours",
        disableFilters: true,
        sort: true,
        style: { textAlign: "center", color: "orange" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        sortFunc: (a, b, order) => {
          // Convert time strings to numbers
          const timeToNumber = time => {
            const [hours, minutes, seconds] = time.split(':').map(Number);
            return hours * 3600 + minutes * 60 + seconds;
          };
          
          // Convert time strings to numbers for comparison
          const timeA = timeToNumber(a);
          const timeB = timeToNumber(b);
      
          // Perform custom comparison based on order
          if (order === 'asc') {
            return timeA - timeB;
          } else {
            return timeB - timeA;
          }
        },
        filterable: true,
        Cell: cellProps => {
          return <ActiveHrs {...cellProps} />
        },
        footer: info => (
          <>
            <span
              className="d-flex justify-content-center "
              style={{ color: "orange", fontWeight: "200" }}
            >
              {sumofIdleHours("activeHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Idle",
        dataField: "idleHours",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <IdleHrs {...cellProps} />
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("idleHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Manual",
        dataField: "manualHours",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <ManualHrs {...cellProps} />
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("manualHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Break",
        dataField: "breakHours",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <BrkHrs {...cellProps} />
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("breakHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Total",
        dataField: "totalHours",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <Total {...cellProps} />
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("totalHours", timeSheetLists)}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Report Inserted Time",
        dataField: "reportInsertedTime",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: ReportInsertedTime,
        footer: <span />,
        headerStyle: (colum, colIndex) => {
          return { width: "160px", textAlign: "center" }
        },
      },
      {
        text: "Comments",
        dataField: "notworkinghourscomment",
        disableFilters: true,
        filterable: true,
        sort: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        Cell: cellProps => {
          return <div style={{ textAlign: "center", color: cellProps?.cell?.value ? "orange" : 'black' }}>
            {cellProps?.cell?.value ? cellProps?.cell?.value : ''}
          </div>
        },
        footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {''}
            </span>
          </>
        ),
        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
    ],
    [hideDateColumn, timeSheetLists]
  )
  const [tableColumn, setTableColumn] = useState(timeSheetHeaderColumns)

  // Initial Table
  const table_columns = useMemo(() => {
    const result = [
      {
        Header: "Date",
        accessor: "date",
        width: 70,
      },

      {
        Header: "Start Time",
        sort: true,
        accessor: "startTime",
        Cell: row => <StartTime {...row} />,
        width: 70,
      },
      {
        Header: "End Time",
        accessor: "endTime",
        sort: true,
        Cell: cellProps => {
          return <EndTimess {...cellProps} />
        },
        width: 70,
      },
      {
        Header: companySetting?.MainCategory,
        sort: true,
        accessor: "clientName",
        width: 70,
      },
      {
        Header: companySetting?.SubCategory,
        sort: true,
        accessor: "projectName",
        Footer: info => (
          <>
            <strong className="d-flex justify-content-end">Total: </strong>
          </>
        ),
        width: 70,
      },
      {
        Header: "Private",
        sort: true,
        accessor: "privateHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("privateHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Active",
        sort: true,
        accessor: "activeHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("activeHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Idle",
        sort: true,
        accessor: "idleHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("idleHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Manual",
        sort: true,
        accessor: "manualHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("manualHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Break",
        sort: true,
        accessor: "breakHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("breakHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Total",
        sort: true,
        accessor: "totalHours",
        Footer: info => (
          <>
            <span className="d-flex justify-content-center">
              {sumofIdleHours("totalHours", timeSheetLists)}
            </span>
          </>
        ),
        width: 70,
      },
      {
        Header: "Report Inserted Time",
        sort: true,
        accessor: "reportInsertedTime",
        Cell: cellProps => <ReportInsertedTime {...cellProps} />,
        width: 90,
      },
      {
        Header: "Action",
        sort: false,
        width: 50,
        Cell: cellProps => {
          return (
            <div
              role="buttton"
              style={{ cursor: "Pointer" }}
              className="verify-screen-button"
            >
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={() => handleOnExpand(cellProps.row.original, cellProps?.rows)}
                  >
                    Verify Screen
                  </DropdownItem>
                  <DropdownItem
                    href="#"
                    onClick={() => handleVerify(cellProps.row.original)}
                  >
                    View Report
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [hideDateColumn, timeSheetLists])

  const react_table_columns = React.useMemo(() => {
    const result = [
      {
        Header: "Date",
        accessor: "date",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },

      {
        Header: "Start Time",
        accessor: "startTime",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              <StartTime {...cellProps} />
            </div>
          )
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              <EndTimess {...cellProps} />
            </div>
          )
        },
      },
      {
        Header: companySetting?.MainCategory,
        accessor: "clientName",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: companySetting?.SubCategory,
        accessor: "projectName",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Private",
        accessor: "privateHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Active",
        accessor: "activeHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Idle",
        accessor: "idleHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Manual",
        accessor: "manualHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Break",
        accessor: "breakHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Total",
        accessor: "totalHours",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              {cellProps?.cell?.value}
            </div>
          )
        },
      },
      {
        Header: "Report Inserted Time",
        accessor: "reportInsertedTime",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.row?.original?.notworkinghourscomment ? "orange" : 'black' }}>
              <ReportInsertedTime {...cellProps} />
            </div>
          )
        },
      },
      {
        Header: "Comments",
        accessor: "notworkinghourscomment",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div style={{ textAlign: "center", color: cellProps?.cell?.value ? "orange" : 'black' }}>
              {cellProps?.cell?.value ? cellProps?.cell?.value : ""}
            </div>
          )
        },
      },
      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <div role="buttton" style={{ cursor: "Pointer" }}>
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={() => handleOnExpand(cellProps.row.original, cellProps?.rows)}
                  >
                    Verify Screen
                  </DropdownItem>
                  <DropdownItem
                    href="#"
                    onClick={() => handleVerify(cellProps.row.original)}
                  >
                    View Report
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [hideDateColumn, timeSheetLists])

  useEffect(() => {
    const reportsX = (reports || []).map(el => {
      return {
        ...el,
        id: el.timeSummaryDate,
        date: el.timeSummaryDate,
        data: el.projectTimeSheet,
        clientName:el?.projectTimeSheet?.[0]?.clientName,
        ProjectName:el?.projectTimeSheet?.[0]?.displayName,
      }
    })
    setData(reportsX)
  }, [reports])

  useEffect(() => {
    setscreenResponse(screens)
  }, [screens])

  const padZero = value => {
    return value > 9 ? value : `0${value}`
  }

  // Adding private, idle, break hours
  const sumofIdleHours = (key, arr, returnValue) => {
    const timesarr = []
      ;(arr || []).map((item, index) => {
        timesarr.push(item[key])
      })
    const sum = timesarr.reduce(
      (acc, time) => acc.add(moment.duration(time)),
      moment.duration()
    )
    if (returnValue)
      return [
        padZero(Math.floor(sum.asHours())),
        padZero(sum.minutes()),
        padZero(sum.seconds()),
      ].join(":")
    return (
      <>
        <strong>
          {[
            padZero(Math.floor(sum.asHours())),
            padZero(sum.minutes()),
            padZero(sum.seconds()),
          ].join(":")}
        </strong>
      </>
    )
  }

  const compare = (a, b) => {
    var time1 = parseFloat(a.replace(":", ".").replace(/[^\d.-]/g, ""))
    var time2 = parseFloat(b.replace(":", ".").replace(/[^\d.-]/g, ""))
    if (a.match(/.*PM/)) time1 += 12
    if (b.match(/.*PM/)) time2 += 12
    if (time1 < time2) return -1
    if (time1 > time2) return 1
    return 0
  }
  useEffect(() => {
    setTableColumn(timeSheetHeaderColumns)
  }, [hideDateColumn, timeSheetLists])

  useEffect(() => {
    loadTimeSheetLists()
  }, [])

  const loadTimeSheetLists = () => {
    const timesheet = {
      userid: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      fromDate: fromDate,
      toDate: toDate,
    }
    dispatch(getUserTimeSheetReport(timesheet))
  }

  const hidenDate = (value = false) => {
    sethideDateColumn(value)
  }

  const onHandleFilterBtnClicked = () => {
    loadTimeSheetLists()
  }

  const [activeClientName, setActiveClientName] = useState("ALL")
  const [activeProjectName, setActiveProjectName] = useState("ALL")

  const handleProjectFilter = data => {
    setActiveProjectName(data?.name || "ALL")
    setselectedSubcategory(data)
  }
  const onhandleVerified = data => {
    setActiveScreenFilter(data)
  }
  const handleClientFilter = data => {
    setActiveClientName(data?.name || "ALL")
    setselectedMainCategory(data)
    setselectedSubcategory(null)
  }
  const handleHoursFilter = hours => {
    setSelectedHours(hours)
  }

  const filterBasedOnHours = rowData => {
    const filtObj = selectedHours.reduce(
      (a, v) => ({ ...a, [v.dataField]: true }),
      {}
    )
    return (
      (!filtObj.idleHours ||
        (filtObj.idleHours && rowData.idleHours !== "00:00:00")) &&
      (!filtObj.activeHours ||
        (filtObj.activeHours && rowData.activeHours !== "00:00:00")) &&
      ((filtObj.breakHours && rowData.breakHours !== "00:00:00") ||
        !filtObj.breakHours) &&
      (!filtObj.privateHours ||
        (filtObj.privateHours && rowData.privateHours !== "00:00:00")) &&
      (!filtObj.manualHours ||
        (filtObj.manualHours && rowData.manualHours !== "00:00:00"))
    )
  }
  useEffect(() => {
    const reportsX = (reports || []).map(el => {
      return {
        ...el,
        id: el.timeSummaryDate,
        date: el.timeSummaryDate,
        data: el.projectTimeSheet,
        clientName:"03:23:22",
        ProjectName:"03:23:22",
      }
    })
    const filterData = reportsX.map(el => {
      const filtWeek = el.projectTimeSheet.filter(
        el =>
          (el.clientName === activeClientName || activeClientName === "ALL") &&
          (el.projectName === activeProjectName ||
            activeProjectName === "ALL") &&
          filterBasedOnHours(el)
      )
      return {
        ...el,
        projectTimeSheet: filtWeek,
        totalHours: sumofIdleHours("totalHours", filtWeek, true),
        privateHours: sumofIdleHours("privateHours", filtWeek, true),
        activeHours: sumofIdleHours("activeHours", filtWeek, true),
        breakHours: sumofIdleHours("breakHours", filtWeek, true),
        idleHours: sumofIdleHours("idleHours", filtWeek, true),
        manualHours: sumofIdleHours("manualHours", filtWeek, true),
      }
    })
    setData(filterData)
  }, [reports, activeClientName, activeProjectName, selectedHours])

  const expandRow = {
    parentClassName: "table-primary bg-opacity-25",
    renderer: row => {
      const list = (row.projectTimeSheet || []).map(el => ({
        ...el,
        hideDate: "",
      }))
      return (
        <div style={{ margin: "-8px" }}>
          <div className="p-0 hide-dates">
            <TableContainer
              data={list || []}
              columns={react_table_columns}
              hidepagination={true}
              sethideHeader={true}
              hideDateColumn={hideDateColumn}
              toggleViewModal={handleOnExpand}
              className="sss"
            />
          </div>
        </div>
      )
    },
    showExpandColumn: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <span />
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <i className="bx bx-caret-up font-size-20"></i>
      }
      return <i className="bx bx-caret-down font-size-20"></i>
    },
  }

  const handleVerify = list => {
    const startDate = moment(new Date(list.startTime)).format("YYYY-MM-DD")
    const params = {
      userId: list?.userId,
      date: startDate,
      accountid: list?.accountId,
    }
    if (startDate !== "Invalid date" && !isReportModal) {
      dispatch(workReports(params))
      setisReportModal(!isReportModal)
    }
    setisReportModal(!isReportModal)
  }

  const handleOnExpand = (list, dataRow) => {
    const startDate = moment(list?.startTime).format("YYYY-MM-DD")
    const endDate = moment(list?.endTime).format("YYYY-MM-DD")
    setActiveScreenFilter("UNVERIFIED")
    const screenVerifyparams = {
      accountid: list.accountId,
      includeBase64: "false",
      filterEmptyResponses: "false",
      startDateTime: startDate, //fromDate,
      endDateTime: endDate, //toDate
    }
    dispatch(screenVerified(screenVerifyparams))

    let expandedRow = !isEmpty(dataRow) ? (dataRow || [])?.map(ele => ele?.original) : []
    let expandedRowIndex = !isEmpty(dataRow) ? dataRow?.findIndex(ele => ele?.original?.displayName === list?.displayName) : 0

    setExpandRowDetails(expandedRow)
    setCurrentIndex(expandedRowIndex)
    setismodal(!ismodal)
  }

  const handleSubmit = e => {
    e.preventDefault()
    sethideDateColumn(
      moment(startDate).format("YYYY/MM/DD") ===
        moment(endDate).format("YYYY/MM/DD")
        ? true
        : false
    )
    onHandleFilterBtnClicked()
  }

  const categoryFilter = value => {
    setselectedMainCategory(value)
    setActiveProjectName(null)
    setActiveClientName(value?.name)
    setselectedSubcategory(null)
  }

  // handle Sub-category
  const subcategoryFilter = value => {
    setActiveProjectName(value?.name)
    // setActiveClientName(value?.name)
  }

  const { teamList } = useSelector(state => ({
    teamList: state?.createteam?.createTeamLookupList,
  }))

  useEffect(() => {
    const filteredData = selectedMainCategory?.id
      ? teamList?.subCategoryLookup?.filter(
        el => el?.categoryId === selectedMainCategory?.id
      )
      : teamList?.subCategoryLookup
    setfiltersubCategory(filteredData)
  }, [selectedMainCategory])

  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
  }, [teamList])

  const handlecancel = () => {
    setisReportModal(!isReportModal)
  }


  useEffect(() => {
    const startDate = moment(expandRowDetails[currentIndex]?.startTime).format("YYYY-MM-DD")
    const endDate = moment(expandRowDetails[currentIndex]?.endTime).format("YYYY-MM-DD")
    const screenVerifyparams = {
      accountid: expandRowDetails[currentIndex]?.accountId,
      includeBase64: "false",
      filterEmptyResponses: "false",
      startDateTime: startDate, //fromDate,
      endDateTime: endDate, //toDate
    }
    dispatch(screenVerified(screenVerifyparams))
  }, [currentIndex])

  const ToggleNextData = () => {
    if (currentIndex < expandRowDetails?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  }

  const TogglePrevData = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  }

  return (
    <React.Fragment>
      <VerifyScreenModal
        isOpen={ismodal}
        toggle={toggleViewModal}
        screens={screenResponse}
        TogglePrevData={TogglePrevData}
        ToggleNextData={ToggleNextData}
        onHandleverified={onhandleVerified}
        activeScreenFilter={activeScreenFilter}
        setscreenResponse={setscreenResponse}
        currentIndex={currentIndex}
        expandRowDetails={expandRowDetails}
        type="verifyscreens"
      />
      <VerifyTeamModal
        isOpen={isReportModal}
        toggle={handleVerify}
        handlecancel={handlecancel}
        myhours={true}
        sethandleAccordion={sethandleAccordion}
        handleAccordion={handleAccordion}
        setisReportModal={setisReportModal}
        HoursReportPage={false}
      />

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"View my hours"}
            breadcrumbItem={"View my hours"}
          />
          <Card>
            <CardBody>
              <FilterLayout
                setStartDate={setStartDate}
                startDate={startDate}
                setEndDate={setEndDate}
                sethideDateColumn={sethideDateColumn}
                endDate={endDate}
                timeSheetLists={reports || []}
                onHandleFilterBtnClicked={onHandleFilterBtnClicked}
                setData={setData}
                hidenDate={hidenDate}
                setSelectedHours={setSelectedHours}
                selectedHours={selectedHours}
                hoursList={hoursList}
                handleProjectFilter={handleProjectFilter}
                handleClientFilter={handleClientFilter}
                activeClientName={activeClientName}
                handleHoursFilter={handleHoursFilter}
                handleSubmit={handleSubmit}
                selectedMainCategory={selectedMainCategory}
                MainCategory={teamList?.categoryLookup}
                categoryFilter={categoryFilter}
                SubCategory={filtersubCategory}
                selectedSubcategory={selectedSubcategory}
                subcategoryFilter={subcategoryFilter}
                companySetting={companySetting}
                activeProjectName={activeProjectName}
                setselectedSubcategory={setselectedSubcategory}
              />
              <Row>
                <Col xs="12" className={!isMobile ? "p-0 table-responsive-align my-teams-align-table" : "viewmy-hours-table"}>
                  <>{
                    !isMobile ? (
                      timeSheetLists?.length === 1 ? (
                        <TableContainer
                          data={timeSheetLists[0]?.projectTimeSheet || []}
                          columns={table_columns}
                          hidepagination={true}
                          toggleViewModal={handleOnExpand}
                          hideDateColumn={hideDateColumn}
                        />
                      ) : (
                        <BootstrapTable
                          keyField="id"
                          data={(timeSheetLists || []).filter(
                            el => !isEmpty(el?.projectTimeSheet)
                          )}
                          columns={tableColumn}
                          expandRow={expandRow}
                          headerClasses="table-light"
                          // classes="table-striped"
                          defaultSortDirection="asc"
                          noDataIndication="Sorry, There are no data to display"
                        />
                      )
                    ) : (
                      <MobileTable
                        data={(timeSheetLists || []).filter(
                          el => !isEmpty(el?.projectTimeSheet)
                        )}
                        isMobile={isMobile}
                        handleOnExpand={handleOnExpand}
                        handleVerify={handleVerify}
                      />
                    )
                  }
                  </>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

VerifyScreen.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VerifyScreen
